import { HostedForm } from "generated/graphql";

export type HostedFormResponse = HostedForm & {
    initialData: Record<string, unknown>;
    logo?: string;
    sessionId?: string;
    slugConfiguration?: {
        id: string | null;
        slug: string | null;
        regionId: string | null;
        referenceBusinessId: string | null;
        referenceContactId: string | null;
        referenceCommunityId: string | null;
        hostedFormId: string | null;
    };
};

export class MalformedHostedFormPayloadError extends Error {
    readonly name = "MalformedHostedFormPayloadError";
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null && !Array.isArray(value);

export const parseHostedFormPayload = (data: unknown): HostedFormResponse | null => {
    if (!isRecord(data)) {
        return null;
    }
    if (!isRecord(data["configuration"])) {
        return null;
    }
    if (!Array.isArray(data["layoutSections"])) {
        return null;
    }
    if (!isRecord(data["initialData"])) {
        return null;
    }
    return data as unknown as HostedFormResponse;
};

export const describePayload = (data: unknown): string => {
    if (data === null) {
        return "null";
    }
    if (typeof data === "string") {
        return `string of length ${data.length}`;
    }
    if (Array.isArray(data)) {
        return `array of length ${data.length}`;
    }
    if (isRecord(data)) {
        return `object with keys ${Object.keys(data).slice(0, 10).join(", ")}`;
    }
    return typeof data;
};
